























import { Component, Vue } from 'vue-property-decorator';
import employeesRepository from '@/modules/employees/employeesRepository';
import Card from '@/components/default/Card.vue';
import Datagrid from '@/components/default/Datagrid.vue';

import notificationService from '@/services/notificationService';
import { EmployeesClient } from '@/data/web-api-client';

@Component({
  components: {
    Card,
    Datagrid,
  },
})
export default class EmployeesTable extends Vue {
  private loading: boolean = false;
  private items: any[] = [];

  private employeesClient = new EmployeesClient(undefined, this.$axios);

  private showContact(e: any) {
    if (e && e.row && e.row.data && e.row.data.id) {
      this.$router.push({ path: `/employees/${e.row.data.id}` });
    }
  }


  private async mounted() {
    await this.loadData();
  }

  async syncEmployees() {
    this.loading = true;

    try {
      await this.employeesClient.syncEmployees();
      await this.loadData();
    } catch(err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  private async loadData() {
    try {
      this.loading = true;
      this.items = (await employeesRepository.get()).data;
      // this.$store.commit('employees/setItems', this.items);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.loading = false;
    }
  }

  get columns() {
    return [
      {
        dataField: 'displayName',
        caption: 'Naam',
      },
      {
        dataField: 'jobTitle',
        caption: 'Titel',
      },
      {
        dataField: 'phone',
        caption: 'Tel.',
      },
      {
        dataField: 'email',
        caption: 'Email',
      },
      {
        dataField: 'canToggleProjectsOnHold',
        caption: 'Project on hold plaatsen',
        dataType: 'boolean'
      },
      {
        dataField: 'accountEnabled',
        caption: 'Account Enabled',
        dataType: 'boolean',
      },
    ];
  }
}
